<template>
  <div
    id="footer">
    <v-layout
      column  
      justify-center
      align-center>
      <!-- start logotype -->
      <img 
        data-aos="fade-up"
        class="footer-logotype"
        src="/img/static/logotype.png" 
        alt="Logotype of David Aguirre">
      <!-- end logotype -->
      <!-- start texts -->
      <p
        class="footer-name">
        Dr. David Aguirre Mar
      </p>
      <p
        class="footer-text">
        Cirujano General Gastroenterólogo
        <br>
        Especialista en: Coloproctología, Laparoscopia 
      </p>
      <!-- end texts -->
    </v-layout>
    <v-layout
      class="footer-items-row"
      row
      wrap>
      <v-flex
        xs12
        sm12
        md3>
        <div
          class="footer-social-media-wrapper">
          <a
            target="_blank"
            class="footer-social-media"
            href="https://www.facebook.com">
            <v-icon
              class="footer-social-media-icon"
              color="#4E66FF">
              mdi-facebook
            </v-icon>
          </a>
          <a
            target="_blank"
            class="footer-social-media"
            href="https://www.instagram.com">
            <v-icon
              class="footer-social-media-icon"
              color="#4E66FF">
              mdi-instagram
            </v-icon>
          </a>
        </div>
      </v-flex>
      <v-flex
        xs12
        sm12
        md6>
        <p
          class="footer-details">
         <v-icon class="details-icon" color="#2F80EC">mdi-email</v-icon> daguirrem@hotmail.com  
         <span
          v-if="$vuetify.breakpoint.mdAndUp">
          | 
         </span>
         <br v-else>
         <v-icon class="details-icon" color="#2F80EC">mdi-phone</v-icon> 81 8347 4143   
         <span
          v-if="$vuetify.breakpoint.mdAndUp">
          | 
         </span>
         <br v-else>
         <v-icon class="details-icon" color="#2F80EC">mdi-map-marker-outline</v-icon> Centro Médico Hospital San José, No. 501 
        </p>
      </v-flex>
      <v-flex
        xs12
        sm12
        md3>
        <p
         :style="$vuetify.breakpoint.mdAndUp ? '':'text-align: center !important; margin-top: 20px'"
          class="footer-address">
          Av. Morones Prieto 300 Pte. No. 501 CP. 
          <br>
          64710, Monterrey, Nuevo León  
        </p>
      </v-flex>
    </v-layout>
    <div
      class="footer-advice-wrapper">
      <p
        class="footer-advice-text">
        El Dr. David Aguirre Mar no se hace responsable del uso inadecuado de 
        la información publicada sin el adecuado consejo médico, que pueda
        manifestar daño directo o indirecto. La información que se presenta en este 
        sitio es solamente con fines de educación al paciente, en ningún momento se 
        busca reemplazar las prescripciones médicas profesionales. Recomendamos necesario 
        acudir con su médico antes de emplear las opiniones o información que se brinda. 
        Las fuentes de información son de renombre con el fin de presentar los conocimientos
        y estándares de manejo vigentes a la fecha de la publicación. Se le reitera al lector 
        que se debe buscar consulta de su médico para tratar la información presentada antes 
        de su aplicación. Para mayor información, escríbanos a: daguirrem@hotmail.com.  
      </p>
    </div>
    <div
      class="footer-rights-options">
      <p
        class="footer-website-rights">
        Derechos reservados Dr. David Aguirre Mar
      </p>
      <v-spacer
        class="footer-rights-spacer"
      ></v-spacer>
      <br
        class="footer-rights-br">
      <a  
        style="margin-right: 10px;"
        class="a-footer-tag"
        href="/pdfs/pdf1.pdf">
        <p
          class="footer-terms-privacy">
          Aviso de privacidad
        </p>
      </a>
      <a 
        class="a-footer-tag"
        href="/pdfs/pdf2.pdf">
        <p
          class="footer-terms-privacy">
          Términos y condiciones
        </p>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  
}
</script>
<style 
  scoped>
  @media screen and (max-width: 959px) {
    .footer-rights-br {
      display: flex !important
    }
    .footer-rights-spacer {
      display: none !important
    }
    .footer-social-media {
      margin-right: 0px !important;
    }
    .footer-details {
      margin-top: 10px
    }
    .footer-social-media-wrapper {
      align-items: center !important;
      justify-items: center !important;
      display: contents !important;
    }
  }
  .footer-rights-br {
    display: none ;
  }
  #footer {
    height: auto;
    z-index: 3;
    position: relative;
    background-color: white;
  }
  .a-footer-tag {
    text-decoration: none !important;
    text-transform: none !important;
  }
  .footer-website-rights {
    font-size: 12px;
    color: #B2B2B2;
    font-family: 'Roboto', sans-serif;
    text-align: center
  }
  .footer-terms-privacy {
    font-size: 12px;
    color: #B2B2B2;
    font-family: 'Roboto', sans-serif;
    text-align: center;
    text-decoration: underline;
  }
  .footer-rights-options {
    padding: 12px 25px 12px 25px; 
    margin-top: 14px;
    display: flex;
    border-top-style: solid;
    border-top-color: rgba(0, 0, 0, 0.081);
    border-top-width: 1px
  }
  .footer-logotype {
    margin-top: 40px;
    margin-bottom: 20px;
    align-self: center;
    width: 50px;
    height: 50px
  }
  .footer-name {
    font-size: 40px;
    color: #5c5c5c;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    text-align: center
  }
  .footer-text {
    font-size: 15px;
    color: #666666;
    font-family: 'Roboto', sans-serif;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .footer-social-media {
    margin-right: 12px;
    font-size: 24px;
    align-self: center;
    text-decoration: none;
    text-transform: none;
  }
  .footer-items-row {
    padding-right: 20px;
    padding-left: 20px;
    margin: 20px 0px 0px 0px !important;
  }
  .footer-social-media-wrapper {
    display: flex;
  }
  .footer-address {
    text-align: right;
    font-size: 12px;
    color: #5c5c5c;
    font-family: 'Roboto', sans-serif;
  }
  .footer-details {
    font-size: 12px;
    color: #5c5c5c;
    font-family: 'Roboto', sans-serif;
    text-align: center
  }
  .footer-social-media-icon {
    font-size: 28px;
  }
  .details-icon {
    font-size: 20px
  }
  .footer-advice-text {
    margin-top: 20px;
    text-align: center;
    font-size: 11px;
    color: #66666659;
    max-width: 95%;
    font-family: 'Roboto', sans-serif;
  }
  .footer-advice-wrapper {
    align-self: center;
    align-items: center;
    justify-content: center;
    display: inline-flex;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>